function spbcGetGoogleQrCode() {
	var data = {};
	var res = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_get_google_qr_code';

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			res = result;
		},
	});
	return res;
}

function spbcCheckGoogleCode() {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_check_google_code';
	data.code = jQuery('#spbct-google-qr-code input').val();

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				jQuery('#spbct-google-qr-code').dialog( "close" );
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

function spbcDisableG2fa( element ) {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_disable_google_2fa';
    data.user_id = jQuery(element).data('user-id');

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

function spbcCheckVulnerability(list, type = 'install') {

	let data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = type === 'install' ? 'spbc_check_vulnerability_install' : 'spbc_check_vulnerability_list';
    data.list = list;

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				if (type === 'install') {
					spbcCheckVulnerabilityInstallRender(result.list, result.msg)
				}
				if (type === 'list') {
					spbcCheckVulnerabilityListRender(result.list, result.msg)
				}
			} else {
				console.log(result);
			}
		},
	});
}

function spbcCheckVulnerabilityListRender(list, msg) {
	let card;
	let badge;

	list.forEach(el => {
		badge = document.createElement('div');
		badge.classList.add('notice', 'notice-error', 'error-message');
		badge.innerHTML = '<p>' + msg + '</p>';
		card = document.querySelector('.themes .theme[data-slug=' + el + ']');
		if (card) {
			card.appendChild(badge);
		}
	});
}

function spbcCheckVulnerabilityInstallRender(list, msg) {
	let card;

	let badge = document.createElement('div');
	badge.classList.add('notice');
	badge.innerHTML = '<p>' + msg + '</p>';

	list.forEach(el => {
		card = document.querySelector('.theme-id-container .theme-actions a[data-slug=' + el + ']')
		if (card) {
			card.parentNode.parentNode.parentNode.appendChild(badge);
		}
	});
}

jQuery(document).ready(function(){

	if (window.location.href.indexOf("themes.php") > -1 && spbcSettings.vulnerabilityShowList) {
		let slugs_state = [];
		let slugs = [];
		let slugs_nodes;
		let version;

		setInterval(function() {
			slugs_nodes = document.querySelectorAll('.themes .theme[data-slug]');

			if (slugs_nodes.length > 0) {
				slugs = [];
				slugs_nodes.forEach(function(el) {
					version = el.querySelector('img').src ? el.querySelector('img').src.match(/ver=([\d\.]+)/)[1] : null;
					slugs.push(el.dataset.slug, version);
				});
			}

			if (JSON.stringify(slugs) != JSON.stringify(slugs_state)) {
				slugs_state = slugs;
				spbcCheckVulnerability(slugs, 'list');
			}
		}, 500);
    }

	if (window.location.href.indexOf("theme-install.php") > -1 && spbcSettings.vulnerabilityShowInstall) {
		let slugs_state = [];
		let slugs = [];
		let slugs_nodes;

		setInterval(function() {
			slugs_nodes = document.querySelectorAll('.theme-id-container .theme-actions a[data-slug]');

			if (slugs_nodes.length > 0) {
				slugs = [];
				slugs_nodes.forEach(function(el) {
					slugs.push(el.dataset.slug);
				});
			}

			if (JSON.stringify(slugs) != JSON.stringify(slugs_state)) {
				slugs_state = slugs;
				spbcCheckVulnerability(slugs);
			}
		}, 500);
    }

	// Auto update banner close handler
	jQuery('.spbc_update_notice').on('click', 'button', function(){
		spbc_setCookie('spbc_update_banner_closed', 1, 86400 * 30);
	});

	// Enable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-enable', function(e){

		e.preventDefault();
		var spbcGoogleQrCode = spbcGetGoogleQrCode();

		if( spbcGoogleQrCode.success ) {
			var qr_code_div = jQuery('#spbct-google-qr-code-img');
			qr_code_div.html(spbcGoogleQrCode.data.img + '<p>' + spbcGoogleQrCode.data.code + '</p>');
			jQuery('#spbct-google-qr-code input').val('');
			jQuery('#spbct-google-qr-code').dialog({
				modal: true,
				title: 'Google authenticator activation',
				buttons: {
					Cancel: function() {
						jQuery( this ).dialog( "close" );
					},
					Ok: function() {
						spbcCheckGoogleCode();
					}
				},
				draggable: false,
				resizable: false,
			});
		} else {
			alert(spbcGetGoogleQrCode.data);
		}

	});

	// Disable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-disable', function(e){

		e.preventDefault();
		if( confirm( 'Are you sure?' ) ) {
			spbcDisableG2fa( this );
		}

	});

	var refresh_user_online_counter = function( result, data, params ){
		setTimeout(function () {
			if( result !== null ){
				jQuery('.spbc-admin_bar--user_counter').html(result.count);
				if( result.count <= 3 ) {
					jQuery('#wp-admin-bar-spbc_admin_bar__online_admins').show();
					jQuery('.spbc-admin_bar--online_admins').html(result.users.join(', '));
				}else{
					jQuery('#wp-admin-bar-spbc_admin_bar__online_admins').hide();
				}

			}
			spbc_sendAJAXRequest( data, params );
		}, 15000 );
	};

	if( +spbcSettings.admin_bar__admins_online_counter === 1 ) {
		refresh_user_online_counter(null, {action: 'spbc_get_authorized_admins'}, {callback: refresh_user_online_counter});
	}

	// Dismiss admin banner
	jQuery('body').on('click', '.spbct-notice-dismiss-link', function(e){
		jQuery(e.target).siblings('.notice-dismiss').click();
	});
	jQuery('body').on('click', '.spbc-notice .notice-dismiss', function(e){
		const bannerId = jQuery(e.target).parent('.notice').attr('id');
		if( bannerId ) {
			spbc_sendAJAXRequest({'action' : 'spbc_dismiss_banner', 'banner_id' : bannerId }, {});
			jQuery(e.target).parent('.notice').after('<div id="spbct-notice-dismiss-success" class="notice notice-success is-dismissible"><p>'+spbcSettings.spbctNoticeDismissSuccess+'</p></div>');
			setTimeout(function () {
				jQuery('#spbct-notice-dismiss-success').fadeOut();
			}, 2000);
		}
	});

	if (+spbcSettings.needToWhitelist === 1) {
		spbc_sendAJAXRequest( { 'action' : 'spbc_private_list_add' }, { 'callback' : null } );
	}
});

function spbcSummaryShowCDNCheckerTable()
{
	event.preventDefault()
	let table = document.getElementById('spbc_stats_cdn_checker_table')
	if (typeof (table) !== 'undefined') {
		if (table.style.display === 'block') {
			table.style.display = 'none'
		} else {
			table.style.display = 'block'
		}
	}
}
